import { createApiSaga } from "redux-store/api-sagas";
import { applicationService } from "service/application";

import {
  EDIT_APPLICATION,
  EDIT_APPLICATION_FAILURE,
  EDIT_APPLICATION_SUCCESS,
  LOAD_APPLICATIONS_BY_ACCOUNT_SUCCESS,
  LOAD_APPLICATIONS_BY_ACCOUNT_FAILURE,
  LOAD_APPLICATIONS_FAILURE,
  LOAD_APPLICATIONS_SUCCESS,
  UPLOAD_APPLICATION,
  UPLOAD_APPLICATION_FAILURE,
  UPLOAD_APPLICATION_SUCCESS,
} from "./actions";

const editApplicationsSaga = createApiSaga({
  service: applicationService.edit,
  serviceName: "applicationService.edit",
  fetchAction: EDIT_APPLICATION,
  successAction: EDIT_APPLICATION_SUCCESS,
  failureAction: EDIT_APPLICATION_FAILURE,
  reload: false,
});

const reloadApplicationsSaga = createApiSaga({
  service: applicationService.load,
  serviceName: "applicationService.load",
  successAction: LOAD_APPLICATIONS_BY_ACCOUNT_SUCCESS,
  failureAction: LOAD_APPLICATIONS_BY_ACCOUNT_FAILURE,
  reload: true,
});

const reloadAllApplicationsSaga = createApiSaga({
  service: applicationService.loadAll,
  serviceName: "applicationService.loadAll",
  successAction: LOAD_APPLICATIONS_SUCCESS,
  failureAction: LOAD_APPLICATIONS_FAILURE,
  reload: true,
});

const uploadApplicationsSaga = createApiSaga({
  service: applicationService.upload,
  serviceName: "applicationService.upload",
  fetchAction: UPLOAD_APPLICATION,
  successAction: UPLOAD_APPLICATION_SUCCESS,
  failureAction: UPLOAD_APPLICATION_FAILURE,
  reload: false,
});

export {
  editApplicationsSaga,
  reloadAllApplicationsSaga,
  reloadApplicationsSaga,
  uploadApplicationsSaga,
};
